import { createRouteRef } from '@backstage/core-plugin-api';

const rootRouteRef = createRouteRef({
  id: "techdocs:index-page"
});
const rootDocsRouteRef = createRouteRef({
  id: "techdocs:reader-page",
  params: ["namespace", "kind", "name"]
});
const rootCatalogDocsRouteRef = createRouteRef({
  id: "techdocs:catalog-reader-view"
});

export { rootCatalogDocsRouteRef, rootDocsRouteRef, rootRouteRef };
//# sourceMappingURL=routes.esm.js.map
